(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-rich-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function reveal(section) {
      section.querySelectorAll('.rtf-float').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    function initSection(section) {
      if (section.dataset.rtfAnimInit) return;
      section.dataset.rtfAnimInit = 'true';

      if (!('IntersectionObserver' in window)) {
        reveal(section);
        return;
      }

      section.classList.add('rtf-anim-ready');

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              reveal(section);
              observer.disconnect();
            }
          });
        },
        { threshold: 0.25 }
      );

      observer.observe(section);
    }

    function initAll(root) {
      root.querySelectorAll('.rtf-section').forEach(initSection);
    }

    initAll(document);
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
